(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~steps"],{

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/steps/item.jsx
// 样式文件
// import "./style/index.scss";

/* harmony default export */ var item = ({
  name: "MegStepsItem",
  props: {
    className: {
      type: String
    },
    title: {
      type: String
    },
    discription: {
      type: String
    },
    description: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    index: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": external_classnames_default()("meg-steps-item", "meg-steps-item-".concat(this.size), this.className, this.index > this.current ? "meg-steps-item-backlog" : this.index < this.current ? "meg-steps-item-finished" : "meg-steps-item-processing")
    }, [h("div", {
      "class": external_classnames_default()("meg-steps-item-tail", "meg-steps-item-tail-".concat(this.size))
    }), h("div", {
      "class": external_classnames_default()("meg-steps-item-icon", "meg-steps-item-icon-".concat(this.size))
    }, [this.index < this.current ? h("meg-icon", {
      attrs: {
        name: "megui-check",
        height: this.size === "default" ? "32px" : "24px",
        width: this.size === "default" ? "16px" : "14px"
      }
    }) : this.index]), h("div", {
      "class": "meg-steps-item-content"
    }, [h("div", {
      "class": external_classnames_default()("meg-steps-item-title", "meg-steps-item-title-".concat(this.size))
    }, [this.title]), h("div", {
      "class": "meg-steps-item-discription"
    }, [this.$scopedSlots.description && this.$scopedSlots.description() || this.description || this.discription])])]);
  }
});
// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// CONCATENATED MODULE: ./src/components/steps/steps.jsx
// 样式文件
// import "./style/index.scss";


/* harmony default export */ var steps = ({
  name: "MegSteps",
  props: {
    className: {
      type: String
    },
    direction: {
      type: String,
      default: "horizontal"
    },
    size: {
      type: String,
      default: "default"
    },
    current: {
      type: Number,
      default: 1
    },
    labelPlacement: {
      type: String,
      default: "horizontal"
    }
  },
  methods: {
    click: function click() {}
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("section", {
      "class": external_classnames_default()("meg-steps", this.direction === "vertical" ? "meg-steps-vertical" : "meg-steps-horizontal", this.direction === "horizontal" && this.labelPlacement === "vertical" ? "meg-steps-label-vertical" : "", this.className)
    }, [this.$slots.default.filter(function (child) {
      return child.tag;
    }).map(function (child, index) {
      var stepProps = {
        props: {}
      };
      stepProps.props.current = _this.current;
      stepProps.props.size = _this.size;
      stepProps.props.index = index + 1;
      return Object(vnode["a" /* cloneElement */])(child, stepProps);
    })]);
  }
});
// CONCATENATED MODULE: ./src/components/steps/index.jsx


steps.Item = item;

steps.install = function (Vue) {
  Vue.component(steps.name, steps);
  Vue.component(item.name, item);
};

/* harmony default export */ var components_steps = __webpack_exports__["default"] = (steps);

/***/ })

}]);